<ic-root>
	<header>
		<ic-contact [supportInfo]="supportInfo()" />
	</header>
	<div class="content-wrapper" contents>
		<router-outlet />
	</div>
</ic-root>
